module.exports = __webpack_public_path__ + "media/images/payments/klarna-bf5bcdbf1e484b458c06d4b1a1320e68.svg";